import Vue from 'vue'
import Router from 'vue-router'
import Exhibition from '@/components/exhibition'
import Home from '@/components/home'
import HumanDirectory from '@/components/manpowerHuman/HumanDirectory'
import Search from '@/components/searchPage/search'
import IssueManpower from '@/components/FAQ/issueManpower'
import IssueManpower1 from '@/components/FAQ/issueManpower1'
import IssueManpower2 from '@/components/FAQ/issueManpower2'
import IssueManpower3 from '@/components/FAQ/issueManpower3'
import Labour from '@/components/Labour/labour'
import LabourParticulars from '@/components/Labour/labourParticulars'
import Manpower from '@/components/Manpower/manpower'
import ManpowerParticulars from '@/components/Manpower/manpowerParticulars'
import ManpowerParticulars1 from '@/components/Manpower/manpowerParticulars1'
import ManpowerParticulars2 from '@/components/Manpower/manpowerParticulars2'
import ManpowerParticulars3 from '@/components/Manpower/manpowerParticulars3'
import ManpowerParticulars4 from '@/components/Manpower/manpowerParticulars4'
import ManpowerParticulars5 from '@/components/Manpower/manpowerParticulars5'
import ManpowerParticulars6 from '@/components/Manpower/manpowerParticulars6'
import ManpowerParticulars7 from '@/components/Manpower/manpowerParticulars7'
import WelfareRemuneration from '@/components/WelfareRemuneration/welfareRemuneration'
import WelfareRemuneration1 from '@/components/WelfareRemuneration/welfareRemuneration1'
import WelfareRemuneration2 from '@/components/WelfareRemuneration/welfareRemuneration2'
import ApplyData from '@/components/ApplyData/applyData'
import ApplyData1 from '@/components/ApplyData/applyData1'
import Finance from '@/components/Finance/finance'
import Finance1 from '@/components/Finance/finance1'
import Finance2 from '@/components/Finance/finance2'
import Finance3 from '@/components/Finance/finance3'
import Finance4 from '@/components/Finance/finance4'
import Finance5 from '@/components/Finance/finance5'
import FinanceHome from '@/components/Finance/financeHome'
import AssetFlow from '@/components/assetflow/assetFlow'
import AssetFlow1 from '@/components/assetflow/assetFlow1'
import AssetFlow2 from '@/components/assetflow/assetFlow2'
import AssetFlow3 from '@/components/assetflow/assetFlow3'
import AssetFlow4 from '@/components/assetflow/assetFlow4'
import AssetHome from '@/components/assetflow/assetHome'
import Administrative from '@/components/Administrative/administrative'
import Administrative1 from '@/components/Administrative/administrative1'
import Administrative2 from '@/components/Administrative/administrative2'
import Administrative3 from '@/components/Administrative/administrative3'
import Administrative4 from '@/components/Administrative/administrative4'
import Administrative6 from '@/components/Administrative/administrative6'
import Administrative7 from '@/components/Administrative/administrative7'
import Administrative8 from '@/components/Administrative/administrative8'
import Administrative9 from '@/components/Administrative/administrative9'
import Administrative10 from '@/components/Administrative/administrative10'
import AdministrativeHome from '@/components/Administrative/administrativeHome'
import Appendix from '@/components/Appendix/appendix'
import Appendix1 from '@/components/Appendix/appendix1'
import Appendix2 from '@/components/Appendix/appendix2'
import Appendix3 from '@/components/Appendix/appendix3'
import Appendix4 from '@/components/Appendix/appendix4'
import Appendix5 from '@/components/Appendix/appendix5'
import Appendix6 from '@/components/Appendix/appendix6'
import Scene from '@/components/pageScene/scene'
import Scene1 from '@/components/pageScene/scene1'
import Scene2 from '@/components/pageScene/scene2'
import Scene3 from '@/components/pageScene/scene3'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Exhibition',
      component: Exhibition
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/humanDirectory',
      name: 'HumanDirectory',
      component: HumanDirectory
    },
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/issueManpower',
      name: 'IssueManpower',
      component: IssueManpower
    },
    {
      path: '/issueManpower1',
      name: 'IssueManpower1',
      component: IssueManpower1
    },
    {
      path: '/issueManpower2',
      name: 'IssueManpower2',
      component: IssueManpower2
    },
    {
      path: '/issueManpower3',
      name: 'IssueManpower3',
      component: IssueManpower3
    },
    {
      path: '/labour',
      name: 'Labour',
      component: Labour
    },
    {
      path: '/labourParticulars',
      name: 'LabourParticulars',
      component: LabourParticulars
    },
    {
      path: '/manpower',
      name: 'Manpower',
      component: Manpower
    },
    {
      path: '/manpowerParticulars',
      name: 'ManpowerParticulars',
      component: ManpowerParticulars
    },
    {
      path: '/manpowerParticulars1',
      name: 'ManpowerParticulars1',
      component: ManpowerParticulars1
    },
    {
      path: '/manpowerParticulars2',
      name: 'ManpowerParticulars2',
      component: ManpowerParticulars2
    },
    {
      path: '/manpowerParticulars3',
      name: 'ManpowerParticulars3',
      component: ManpowerParticulars3
    },
    {
      path: '/manpowerParticulars4',
      name: 'ManpowerParticulars4',
      component: ManpowerParticulars4
    },
    {
      path: '/manpowerParticulars5',
      name: 'ManpowerParticulars5',
      component: ManpowerParticulars5
    },
    {
      path: '/manpowerParticulars6',
      name: 'ManpowerParticulars6',
      component: ManpowerParticulars6
    },
    {
      path: '/manpowerParticulars7',
      name: 'ManpowerParticulars7',
      component: ManpowerParticulars7
    },
    {
      path: '/welfareRemuneration',
      name: 'WelfareRemuneration',
      component: WelfareRemuneration
    },
    {
      path: '/welfareRemuneration1',
      name: 'WelfareRemuneration1',
      component: WelfareRemuneration1
    },
    {
      path: '/welfareRemuneration2',
      name: 'WelfareRemuneration2',
      component: WelfareRemuneration2
    },
    {
      path: '/applyData',
      name: 'ApplyData',
      component: ApplyData
    },
    {
      path: '/applyData1',
      name: 'ApplyData1',
      component: ApplyData1
    },
    {
      path: '/finance',
      name: 'Finance',
      component: Finance
    },
    {
      path: '/finance1',
      name: 'Finance1',
      component: Finance1
    },
    {
      path: '/finance2',
      name: 'Finance2',
      component: Finance2
    },
    {
      path: '/finance3',
      name: 'Finance3',
      component: Finance3
    },
    {
      path: '/finance4',
      name: 'Finance4',
      component: Finance4
    },
    {
      path: '/finance5',
      name: 'Finance5',
      component: Finance5
    },
    {
      path: '/financeHome',
      name: 'FinanceHome',
      component: FinanceHome
    },
    {
      path: '/assetFlow',
      name: 'AssetFlow',
      component: AssetFlow
    },
    {
      path: '/assetFlow1',
      name: 'AssetFlow1',
      component: AssetFlow1
    },
    {
      path: '/assetFlow2',
      name: 'AssetFlow2',
      component: AssetFlow2
    },
    {
      path: '/assetFlow3',
      name: 'AssetFlow3',
      component: AssetFlow3
    },
    {
      path: '/assetFlow4',
      name: 'AssetFlow4',
      component: AssetFlow4
    },
    {
      path: '/assetHome',
      name: 'AssetHome',
      component: AssetHome
    },
    {
      path: '/administrative1',
      name: 'Administrative1',
      component: Administrative1
    },
    {
      path: '/administrative',
      name: 'Administrative',
      component: Administrative
    },
    {
      path: '/administrative2',
      name: 'Administrative2',
      component: Administrative2
    },
    {
      path: '/administrative3',
      name: 'Administrative3',
      component: Administrative3
    },
    {
      path: '/administrative4',
      name: 'Administrative4',
      component: Administrative4
    },
    {
      path: '/administrative6',
      name: 'Administrative6',
      component: Administrative6
    },
    {
      path: '/administrative7',
      name: 'Administrative7',
      component: Administrative7
    },
    {
      path: '/administrative8',
      name: 'Administrative8',
      component: Administrative8
    },
    {
      path: '/administrative9',
      name: 'Administrative9',
      component: Administrative9
    },
    {
      path: '/administrative10',
      name: 'Administrative10',
      component: Administrative10
    },
    {
      path: '/administrativeHome',
      name: 'AdministrativeHome',
      component: AdministrativeHome
    },
    {
      path: '/appendix',
      name: 'Appendix',
      component: Appendix
    },
    {
      path: '/appendix1',
      name: 'Appendix1',
      component: Appendix1
    },
    {
      path: '/appendix2',
      name: 'Appendix2',
      component: Appendix2
    },
    {
      path: '/appendix3',
      name: 'Appendix3',
      component: Appendix3
    },
    {
      path: '/appendix4',
      name: 'Appendix4',
      component: Appendix4
    },
    {
      path: '/appendix5',
      name: 'Appendix5',
      component: Appendix5
    },
    {
      path: '/appendix6',
      name: 'Appendix6',
      component: Appendix6
    },
    {
      path: '/scene',
      name: 'Scene',
      component: Scene
    },
    {
      path: '/scene1',
      name: 'Scene1',
      component: Scene1
    },
    {
      path: '/scene2',
      name: 'Scene2',
      component: Scene2
    },
    {
      path: '/scene3',
      name: 'Scene3',
      component: Scene3
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js